import React from 'react'
import { Route, Switch } from 'wouter'

import MatchProducts from './match_products'
import EditMatchs from './edit_matchs'

export function MarketPlaceGroup() {
  return (
    <div>
      <Switch>
        <Route path="/market-place/match-products">
          <MatchProducts />
        </Route>
        <Route path="/market-place/edit-matchs">
          <EditMatchs />
        </Route>
      </Switch>
    </div>
  )
}
